/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Disabled_Websites_Enable_LimitedInputs */

const en_disabled_websites_enable_limited = /** @type {(inputs: Disabled_Websites_Enable_LimitedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enable with Limited Compatibility`)
};

const es_disabled_websites_enable_limited = /** @type {(inputs: Disabled_Websites_Enable_LimitedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Habilitar con compatibilidad limitada`)
};

/**
* | output |
* | --- |
* | "Enable with Limited Compatibility" |
*
* @param {Disabled_Websites_Enable_LimitedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const disabled_websites_enable_limited = /** @type {((inputs?: Disabled_Websites_Enable_LimitedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Disabled_Websites_Enable_LimitedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_disabled_websites_enable_limited(inputs)
	return en_disabled_websites_enable_limited(inputs)
});